/** Strip `/api/v1` suffix and return origin, e.g. `https://courtyard-dev-1.thecourtyard.ai`. */
function dashboardOriginFromApiBaseUrl(apiBaseUrl: string): string | null {
  const trimmed = apiBaseUrl.trim();
  if (!trimmed || trimmed === '/api/v1' || !/^https?:\/\//i.test(trimmed)) {
    return null;
  }
  try {
    const withoutApiPath = trimmed.replace(/\/api\/v1\/?$/i, '');
    return new URL(withoutApiPath.endsWith('/') ? withoutApiPath : `${withoutApiPath}/`).origin;
  } catch {
    return null;
  }
}

/**
 * Courtyard web dashboard origin for usage/settings links from the Word add-in.
 * Prefer explicit `COURTYARD_WEB_APP_URL`, else derive from `API_BACKEND_BASE_URL`
 * (same environment host as the dashboard, e.g. `{workspace}.thecourtyard.ai`).
 */
export function webAppBaseUrl(): string {
  const explicit = (process.env.COURTYARD_WEB_APP_URL || '').trim();
  if (explicit) return explicit.replace(/\/$/, '');

  const fromApi = dashboardOriginFromApiBaseUrl(process.env.API_BACKEND_BASE_URL || '');
  if (fromApi) return fromApi;

  if (process.env.NODE_ENV === 'development') return 'http://localhost:5174';
  return 'https://thecourtyard.ai';
}

export function webAppPathUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${webAppBaseUrl()}${normalized}`;
}
